<script>
import { h } from 'vue'
import LoadingIndicator from './LoadingIndicator.vue'
import Poll from './Poll.vue'
import VideoPlayer from './VideoPlayer.vue'
import UpVote from './UpVote.vue'
import CommentsModal from './CommentsModal.vue'
import ArticleShare from './ArticleShare.vue'

export default {
	props: {
		content: {
			type: String,
			default: '',
		},
	},
	render() {		
		const r = {
			components: {
				LoadingIndicator,
				Poll,
				VideoPlayer,
				UpVote,
				CommentsModal,
				ArticleShare,
			},
			template: `<div class="content">${this.content || ''}</div>`,
			methods: {
				hello() {
					
				},
			},
		};
		return h(r);
	},
};
</script>
